import { defineComponent, ref, watch, onMounted } from 'vue';
import { Input, Button, message } from 'ant-design-vue';
import { EditOutlined, DeleteOutlined, CloseOutlined, PlusOutlined } from '@ant-design/icons-vue';
import complete from '../../assets/完成编辑.png';
import { Plugin } from '@vue/runtime-dom';
import './index.less';
interface DataSource {
  key: string;
  [key: string]: any;
}

export const EditableTable = defineComponent({
  name: 'EditableTable',
  emits: ['change'],
  props: {
    dataSource: {
      type: Array as PropType<DataSource[]>,
      default: () => [],
    },
    isMultiValue: {
      type: Boolean,
      default: false,
    },
    scrollHeight: {
      type: Number,
      default: 500,
    },
    keyEditAble: {
      type: Boolean,
      default: true,
    },
    valueAddAble: {
      type: Boolean,
      default: true,
    },
    deleteAble: {
      type: Boolean,
      default: true,
    },
    columnsBase: {
      type: Array as PropType<string[]>,
      default: () => ['key', 'value'],
    },
    readonlyColumns: {
      type: Array as PropType<string[]>,
      default: () => [''],
    },
    showIndex: {
      type: Boolean,
      default: true,
    },
    showMessage: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const dataSource = ref<DataSource[]>([]);

    // 动态生成列
    const columns = ref<any[]>([]);

    const generateColumns = (dataSource) => {
      if (dataSource && dataSource.length > 0) {
        const keys = Object.keys(dataSource[0]);
        columns.value = keys.map((key) => {
          if (props.columnsBase.includes(key)) {
            return {
              title: key,
              dataIndex: key,
              width: '20%',
              customRender: ({ record }: any) => {
                // 检查是否是只读列
                const isReadonly = props.readonlyColumns.includes(key);
                return record.isEditing && !isReadonly ? (
                  <div>
                    <Input
                      value={record[key]}
                      onInput={(e: any) => {
                        record[key] = e.target.value;
                      }}
                    />
                  </div>
                ) : (
                  <div>{record[key]}</div>
                );
              },
            };
          }
        });
      }
    };

    watch(
      () => props.dataSource,
      () => {
        if (props.dataSource.length) {
          dataSource.value = props.dataSource.map((item) => ({
            ...item,
            isEditing: false,
          }));
          generateColumns(props.dataSource);
        } else {
          dataSource.value = [];
        }
      },
      {
        deep: true,
        immediate: true,
      }
    );

    const onEdit = (record: DataSource) => {
      record.isEditing = true;
    };

    const onQuit = (record: DataSource) => {
      record.isEditing = false;
    };

    const onComplete = (record: DataSource) => {
      record.isEditing = false;
      const freezeData = dataSource.value.map(({ isEditing, ...rest }) => rest);
      emit('change', {
        type: 'update',
        record,
        records: freezeData,
      });
      props.showMessage && message.success('保存成功');
    };

    const onDelete = (record: DataSource) => {
      dataSource.value = dataSource.value.filter((item) => item.key !== record.key);
      const freezeData = dataSource.value.map(({ isEditing, ...rest }) => rest);

      emit('change', {
        type: 'delete',
        record,
        records: freezeData,
      });
      props.showMessage && message.success('删除成功');
    };

    return {
      dataSource,
      columns,
      onEdit,
      onQuit,
      onComplete,
      onDelete,
    };
  },

  render() {
    return (
      <>
        {this.columns.length ? (
          <a-table
            class="d-edit-table"
            dataSource={this.dataSource}
            columns={[
              ...(this.showIndex
                ? [
                    {
                      title: '序号',
                      dataIndex: 'index',
                      key: 'index',
                      width: '10%',
                      align: 'center',
                      customRender: ({ index }) => {
                        const number = index + 1;
                        return number < 10 ? `0${number}` : number.toString();
                      },
                    },
                  ]
                : []),
              ...this.columns,
              {
                title: '操作',
                key: 'action',
                customRender: ({ record }: any) => {
                  return record.isEditing ? (
                    <div class="icons-row">
                      <img
                        src={complete}
                        class="icon"
                        onClick={() => this.onComplete(record)}
                        style={{ color: 'green' }}
                      />
                      <CloseOutlined class="icon" onClick={() => this.onQuit(record)} />
                    </div>
                  ) : (
                    <div class="icons-row">
                      <EditOutlined
                        class="icon"
                        onClick={() => this.onEdit(record)}
                        style={{ marginRight: '8px' }}
                      />
                      {this.deleteAble && (
                        <DeleteOutlined class="icon" onClick={() => this.onDelete(record)} />
                      )}
                    </div>
                  );
                },
              },
            ]}
            rowKey="key"
            pagination={false}
            size="middle"
            scroll={{ y: this.scrollHeight }}
          />
        ) : null}
      </>
    );
  },
});

export const DEditableTable: Plugin = {
  install: (app) => {
    // Plugin code goes here
    app.component('DEditableTable', EditableTable);
  },
};
